import React, { useEffect, useRef } from "react";
import styles from "./Carousel.module.css";
import { Link } from "react-router-dom";

const Carousel = () => {
  const spinRef = useRef(null);

  useEffect(() => {
    const ospin = spinRef.current;
    const aEle = [...ospin.getElementsByTagName("a")];
    const radius = 250; // Distance from center
    const imgWidth = 200;
    const imgHeight = 330;
    const totalImages = aEle.length;
    const angleStep = 360 / totalImages;
    let rotationY = 0;
    let autoRotate = true;
    const rotateSpeed = 0.2; // degrees per frame (adjust speed)

    // Initialize positions
    aEle.forEach((ele, i) => {
      ele.style.width = imgWidth + "px";
      ele.style.height = imgHeight + "px";
      ele.style.position = "absolute";
      ele.style.transform = `rotateY(${i * angleStep}deg) translateZ(${radius}px)`;
      ele.style.transition = "transform 1s";
    });

    // Continuous rotation
    function animate() {
      if (autoRotate) {
        rotationY += rotateSpeed;
        ospin.style.transform = `rotateY(${rotationY}deg)`;
      }
      requestAnimationFrame(animate);
    }
    animate();

    // Pause rotation on hover
    ospin.addEventListener("mouseenter", () => {
      autoRotate = false;
    });
    ospin.addEventListener("mouseleave", () => {
      autoRotate = true;
    });
  }, []);

  return (
    <div className={styles.bodyy}>
      <div id="drag-container" className={styles.dragContainer}>
        <div id="spin-container" className={styles.spinContainer} ref={spinRef}>
          <Link to="/checkOutForm?course=UI-UX">
            <img src="/UI-UX1.png" alt="UI/UX course" />
          </Link>
          <Link to="/checkOutForm?course=WebDev">
            <img src="/Web-Dev5.png" alt="Web Development course" />
          </Link>
          <Link to="/checkOutForm?course=AppDev">
            <img src="/App-Dev1.png" alt="App Development course" />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Carousel;
